// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-content ol,\n.main-content ul {\n  padding: revert;\n  list-style: revert;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
